import * as yup from 'yup';

export const MultimediaSchema = yup.object().shape({
  video: yup
    .string()
    .matches(
      /(http(s)?:\/\/(www\.)?youtu(be\.com\/watch\?v=|\.be\/|\.com\/v\/)([\w-])(&(amp;)?[\w?=])?)|(http(s)?:\/\/(www\.)?youtube\.com\/shorts\/([\w-])(&(amp;)?[\w?=])?)|((http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?))/,
      'La URL debe ser un video de Youtube o Vimeo'
    )
    .nullable(),
  video360: yup
    .string()
    .matches(
      /(http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/|\.com\/v\/|\.com\/shorts\/)([\w-])([\w-])(&(amp;)?[\w?=])?)|((http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?))|(www.recorrido360.com.ar\/recorridos\/)|(https:\/\/kuula\.co\/share\/)|(https:\/\/www\.klapty\.com\/tour\/)/,
      'La URL debe ser un video de Youtube, Vimeo, Recorrido360 o Kuula'
    )
    .nullable()
});
